import React, { useCallback, useState } from 'react';
import {
  Button,
  DatePicker,
  KatoSelectTrigger,
  SelectOption,
  TextField,
} from '@app/components';
import { IconSearch } from '@app/icons';
import { RenderFilterProps } from '@app/templates';
import * as yup from 'yup';
import { useForm } from '@app/forms';
import { Doc, Kato } from '@app/models';

export interface CompaniesFilterData extends Partial<Doc> {
  katoCode?: string;
  companyBin?: string;
}

interface Props extends RenderFilterProps<CompaniesFilterData> {}

interface PortfolioData {
  name: string;
  bin: string;
  kato: SelectOption<Kato> | null;
  startDate: Date | null;
  endDate: Date | null;
}

const schema = yup.object().shape({});

function CompaniesFilter(props: Props) {
  const { onSubmit, pending } = props;
  const [tenderNumber, setTenderNumber] = useState<string>('');
  const [companyName, setCompanyName] = useState<string>('');
  const { values, onChange, errors, validate } = useForm<PortfolioData>({
    name: '',
    bin: '',
    kato: null,
    startDate: null,
    endDate: null,
  });

  const onSubmitForm = useCallback(async () => {
    const hasErrors = await validate(schema);
    if (hasErrors) {
      return;
    }
    const params: CompaniesFilterData = {};
    if (!!values.name) {
      params.name = values.name;
    }
    if (!!values.bin) {
      params.companyBin = values.bin;
    }
    if (!!values.startDate) {
      params.createdAt = values.startDate.toJSON();
    }
    if (!!values.endDate) {
      params.endDate = values.endDate.toJSON();
    }
    if (!!values.kato) {
      params.katoCode = values.kato.value.code;
    }
    onSubmit(params);
  }, [validate, values, onSubmit]);

  const onChangeTenderNumber = useCallback(
    (value: string) => setTenderNumber(value),
    []
  );

  const onChangeCompanyName = useCallback(
    (value: string) => setCompanyName(value),
    []
  );

  return (
    <div className="bg-white rounded-xl p-6">
      <div className="w-full flex flex-col gap-6">
        <div>
          <TextField
            label="Наименование партнера"
            placeholder="Введите наименование"
            value={values.name}
            onChange={onChange}
            name={'name'}
            labelClassName="uppercase font-bold tracking-wide text-xs text-foreground"
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
          <div>
            <DatePicker
              value={values.startDate}
              name="startDate"
              onChange={onChange}
              label="дата начала сотрудничества"
              labelClassName="uppercase font-bold tracking-wide text-xs text-foreground"
            />
          </div>
          <div>
            <DatePicker
              value={values.endDate}
              name="endDate"
              onChange={onChange}
              label="дата окончания сотрудничества"
              labelClassName="uppercase font-bold tracking-wide text-xs text-foreground"
            />
          </div>
          <div>
            <TextField
              label="бин"
              placeholder="Выберите БИН"
              value={values.bin}
              onChange={onChange}
              name={'bin'}
              labelClassName="uppercase font-bold tracking-wide text-sm text-foreground"
            />
          </div>
          <div>
            <KatoSelectTrigger
              label="регион"
              value={!!values.kato ? values.kato.value.nameRu : undefined}
              placeholder="Выберите регион"
              name="kato"
              onChange={onChange}
              labelClassName="uppercase font-bold tracking-wide"
              className="space-y-1"
            />
          </div>
        </div>
      </div>
      <div className="flex justify-end mt-6">
        <Button
          loading={pending}
          onClick={onSubmitForm}
          text="Найти"
          icon={IconSearch}
        />
      </div>
    </div>
  );
}

export default CompaniesFilter;
